<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import FlowReportCards from './FlowReportCards.vue';
import LineChart from 'shared/components/charts/LineChart.vue';

const { t } = useI18n();

const props = defineProps({
  report: { type: Object, default: null },
  loading: { type: Boolean, default: false },
});

const lineData = computed(() => {
  const series = props.report?.daily_delivered || {};
  const labels = Object.keys(series).map(date => {
    const [, m, d] = date.split('-');
    return `${d}/${m}`;
  });
  const values = Object.values(series);
  return {
    labels,
    datasets: [
      {
        label: t('FLOW_BUILDER.REPORTS.OVERVIEW.DELIVERED'),
        data: values,
        borderColor: '#3b82f6',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        fill: true,
      },
    ],
  };
});

const hasSeries = computed(() =>
  Object.values(props.report?.daily_delivered || {}).some(v => v > 0)
);
</script>

<template>
  <div class="flex flex-col gap-6">
    <FlowReportCards :report="report" :loading="loading" />
    <div
      class="border border-n-slate-4 bg-n-solid-1 rounded-lg p-4 flex flex-col gap-3"
    >
      <span class="text-sm font-semibold text-n-slate-12">
        {{ t('FLOW_BUILDER.REPORTS.OVERVIEW.DELIVERED_PER_DAY') }}
      </span>
      <div class="h-72">
        <div
          v-if="loading"
          class="h-full rounded-md bg-n-alpha-2 animate-pulse"
        />
        <LineChart v-else-if="hasSeries" :collection="lineData" />
        <div
          v-else
          class="h-full flex items-center justify-center text-sm text-n-slate-10"
        >
          {{ t('FLOW_BUILDER.REPORTS.OVERVIEW.NO_DATA') }}
        </div>
      </div>
    </div>
  </div>
</template>
